import { routeMap } from './routeMap';

export const redirectByDomain = ({ pageId, targetDomain }) => {
  const pageRoutes = routeMap[pageId];

  if (!pageRoutes || !pageRoutes[targetDomain]) {
    window.location.href = routeMap.home[targetDomain];
    return;
  }

  window.location.href = pageRoutes[targetDomain];
};